/* POHISTVO-LINIJA-V1 — mirujoča slika prostorov, izbira dekorja, kopiranje šifer, vstopno gibanje. Brez JS stran deluje (vse vidno, prvi prostor in prvi dekor). */
(function () {
  function init(root) {
    if (root.dataset.plInit) return; root.dataset.plInit = '1';
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var stage = root.querySelector('[data-stage]');
    var frames = stage ? [].slice.call(stage.querySelectorAll('.pl-stage__f')) : [];
    var links = [].slice.call(root.querySelectorAll('[data-room]'));
    function show(k) {
      frames.forEach(function (f) { f.classList.toggle('is-on', f.dataset.k === k); });
      links.forEach(function (a) { if (a.dataset.room === k) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
    }
    // prostor, ki je na sredini zaslona, zamenja mirujočo sliko (samo, ko je oder lepljiv: >= 990 px)
    var rooms = [].slice.call(root.querySelectorAll('.pl-room'));
    if ('IntersectionObserver' in window && rooms.length) {
      var io = new IntersectionObserver(function (es) {
        if (innerWidth < 990) return; es.forEach(function (e) { if (e.isIntersecting) show(e.target.dataset.k); });
      }, { rootMargin: '-45% 0px -45% 0px' });
      rooms.forEach(function (r) { io.observe(r); });
    }
    links.forEach(function (a) { a.addEventListener('mouseenter', function () { if (innerWidth >= 990) show(a.dataset.room); }); a.addEventListener('focus', function () { show(a.dataset.room); }); });

    // dekor: radio skupina s tipkovnico (puščice) in zamenjava renderja
    var dbtn = [].slice.call(root.querySelectorAll('.pl-decor'));
    var dfig = [].slice.call(root.querySelectorAll('.pl-decor-f'));
    function pick(b, focus) {
      dbtn.forEach(function (x) { var on = x === b; x.setAttribute('aria-checked', on ? 'true' : 'false'); x.tabIndex = on ? 0 : -1; });
      dfig.forEach(function (f) { f.classList.toggle('is-on', f.dataset.d === b.dataset.d); });
      if (focus) b.focus();
    }
    dbtn.forEach(function (b, i) {
      b.tabIndex = i === 0 ? 0 : -1;
      b.addEventListener('click', function () { pick(b); });
      b.addEventListener('keydown', function (e) {
        var d = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
        if (d) { e.preventDefault(); pick(dbtn[(i + d + dbtn.length) % dbtn.length], true); }
      });
      // predhodno naloži render, ko se dekor približa (hover/fokus)
      ['mouseenter', 'focus', 'touchstart'].forEach(function (ev) { b.addEventListener(ev, function () { dfig.forEach(function (f) { if (f.dataset.d === b.dataset.d) { var im = f.querySelector('img'); if (im) im.loading = 'eager'; } }); }, { passive: true }); });
    });

    // kopiranje šifer
    var toast = root.querySelector('.pl-toast'), tt;
    root.addEventListener('click', function (e) {
      var b = e.target.closest('.pl-copy'); if (!b) return;
      var txt = b.getAttribute('data-copy') || '';
      var done = function () { if (!toast) return; toast.textContent = root.dataset.copied || 'OK'; toast.hidden = false; clearTimeout(tt); tt = setTimeout(function () { toast.hidden = true; }, 2600); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(txt).then(done, done);
      else { var ta = document.createElement('textarea'); ta.value = txt; document.body.appendChild(ta); ta.select(); try { document.execCommand('copy'); } catch (x) {} ta.remove(); done(); }
    });

    // vstopno gibanje: naslov -> besedilo -> slika, zamik 80 ms; enkrat
    if (!reduce && 'IntersectionObserver' in window) {
      root.classList.add('js');
      var sel = '.pl-col > *, .pl-props dl > div, .pl-room > *, .pl-colours__head > *, .pl-decors, .pl-colours__img, .pl-tech__head > *, .pl-sec > *, .pl-figs dl > div, .pl-type, .pl-lay, .pl-cols3 > div, .pl-made > *, .pl-inq__in > *, .pl-rel li, .pl-faq details';
      var els = [].slice.call(root.querySelectorAll(sel));
      var groups = new Map();
      els.forEach(function (el) { var p = el.parentElement; var n = groups.get(p) || 0; el.style.setProperty('--i', Math.min(n, 6)); groups.set(p, n + 1); el.classList.add('pl-in'); });
      var io2 = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io2.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
      els.forEach(function (el) { io2.observe(el); });
      // podpis: oder se odpre z roba (enkrat)
      if (stage) { stage.classList.add('pl-shut'); requestAnimationFrame(function () { requestAnimationFrame(function () { stage.classList.add('is-open'); }); }); }
      // varovalka: če opazovalec ne sproži (tiskanje, zastarel brskalnik), pokaži vse po 2,5 s
      setTimeout(function () { els.forEach(function (el) { if (el.getBoundingClientRect().top < innerHeight) el.classList.add('is-in'); }); }, 2500);
    }
  }
  function boot() { document.querySelectorAll('[data-pl]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
